import React, { useState } from "react";
import { Button, Container } from "react-bootstrap";
import { RouteProps } from "react-router";
import Content from "Types/Content";

const Contador: React.FC<RouteProps> = () => {
  const [value, setValue] = useState(0);

  return (
    <Container>
      <Button onClick={() => setValue(prev => prev + 1)}>{value}</Button>
    </Container>
  );
};

export default new Content({
  Component: Contador,
  title: "Contador",
  route: "contador"
});
